import { render, staticRenderFns } from "./efItem1.vue?vue&type=template&id=0f956373&lang=pug&"
import script from "./efItem1.vue?vue&type=script&lang=js&"
export * from "./efItem1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports